import { useAuthenticator } from '@aws-amplify/ui-react';

export const REDIRECT_PARAM_NAME = 'redirectTo';
export function loginRedirectURL(url: URL) {
  const redirectTo = new URLSearchParams([[REDIRECT_PARAM_NAME, `${url.pathname}${url.search}`]]);
  return `/login?${redirectTo.toString()}`;
}

export enum AuthTypeEnum {
  USER_PASSWORD_AUTH = 'USER_PASSWORD_AUTH',
}

export function useAuthType() {
  const { user } = useAuthenticator();
  const type = user.signInDetails?.authFlowType;

  return type;
}
